import { LANGS, useT } from "../lib/i18n.jsx";

export default function LangSelector({ compact = false, stacked = false, docked = false }) {
  const { lang, setLang } = useT();
  return (
    // Bottom-left is where the panel's bottom sheet lives on a phone, so the
    // language picker moves to the top-right corner there (item 0093).
    // Stacked band with a route (item 0314): the directions panel needs the
    // left column down to 64px, so the picker joins Reset view in one row at
    // the bottom, right-aligned next to the zoom column.
    <div
      className={
        "absolute z-10 " +
        // Portrait phone (item 0373): the menu docks at the TOP, so the
        // picker goes back down, to the bottom-left corner.
        (compact
          ? docked
            ? "bottom-3 left-3"
            : "right-3 top-3"
          : stacked
            ? "bottom-3 right-[68px]"
            : "bottom-20 left-3")
      }
    >
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className="appearance-none rounded-lg bg-slate-800 px-4 py-2.5 pr-8 text-sm font-medium
                   text-white shadow-md outline-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path d='M1 1l5 5 5-5' stroke='white' stroke-width='2' fill='none' stroke-linecap='round'/></svg>\")",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 10px center",
        }}
      >
        {LANGS.map(([code, label]) => (
          <option key={code} value={code}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
}
